import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EntityDetail } from '../Models/entity-detail';
import { BankDetail } from '../Models/billing';
import { Auditors } from '../Models/auditModel';
import { Address, Corporate } from '../Models/contacts';
import { PersonalDetails } from '../Models/contacts';

@Injectable({
    providedIn: 'root'
})

export class EntityService {
    public entityDetail = new EntityDetail();
    public personalDetail =new PersonalDetails();
    public bankDetail = new BankDetail();
    public auditors = new Auditors();
    public homeAddressModel = new Address();
    public postalAddressModel = new Address();
    public corporate = new Corporate();
    public state;
    public clientId;
    public entityId;
    private headers:HttpHeaders = new HttpHeaders();
    public bareTrustRows = [{
        specialPurposeCompany: {},
        clientId:0,
        entityId:0,
        childEntityId:0,
        bareTrustName:'',
        ABN:'',
        addRow: true
    }];
    specialPurposeCompRow: any[] = [{
        company: '',
        ABN: '',
        ACN: '',
        AnniversaryDate: ''
    }];

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  }

  GetEntityDetails(EntityID) {
    return this.http.get<any>('EntityProfile/GetEntityDetails?EntityID=' + EntityID )
  }

  GetEntityProfileOpportunityList(EntityID) {
    return this.http.get<any>('EntityProfile/GetEntityProfileOpportunityList?EntityID=' + EntityID)
  }

  GetEntitiesList(EntityID,entitytypeId) {
    return this.http.get<any>('EntityProfile/GetEntitiesList?EntityID=' + EntityID + '&EntityTypeId=' + entitytypeId)
  }

  DeleteTrust(Id) {
    return this.http.get<any>('EntityProfile/DeleteTrust?Id=' + Id)
  }

  GetTrustList(EntityID) {
    return this.http.get<any>('EntityProfile/GetTrustList?EntityID=' + EntityID)
  }

  GetRelatedEntityList(EntityID) {
    return this.http.get<any>('EntityProfile/GetRelatedEntityList?EntityID=' + EntityID)
  }

  AddNewEntities(type, EntityType, EntityName, Prospects) {
    return this.http.get<any>('EntityProfile/AddNewEntities?Trusttype=' + type + '&EntityType=' + EntityType + '&EntityName=' + EntityName + '&Prospect=' + Prospects)
  }

  GetEntityProfileJobList(EntityID) {
    return this.http.get<any>('EntityProfile/GetEntityProfileJobList?EntityID=' + EntityID)
  }

  addEditMemberDetails(data) {
    return this.http.post<any>('Member/AddEntityMember', data)
  }

  getMembersList(entityId, memberId,type) {
    return this.http.get<any>('Member/GetEntityMember?EntityId=' + entityId + '&MemberId=' + memberId+'&Type='+type)
  }

  deleteMember(memberId,type){
    return this.http.get<any>('Member/DeleteMemberById?memberId='+ memberId + '&type='+type)
  }

  addEditClient(clientData) {
    return this.http.post<any>('Client/AddEditClient', clientData)
  }

  addEditSpouseDetails(clientData) {
    return this.http.post<any>('Client/AddEditSpouseInfo', clientData)
  }

  GetClientList(searchTxt, isArchive) {
    return this.http.get<any>('Client/GetClientList?searchTxt=' + searchTxt + '&isArchive=' + isArchive);
  }

  GetEntitiesByClientId(clientId) {
    return this.http.get<any>('Entity/GetEntityByClient?ClientId=' + clientId + '');
  }

  addEditEntityInformation(entityData) {
    return this.http.post<any>('Entity/PostEntityDetails', entityData)
  }

  GetEntityName(selectedEntityTypeId, cid) {
    return this.http.get<any>('Entity/GetEntityByEntityTypeId?entityId='+selectedEntityTypeId + '&clientId='+cid)
  }

  addBankDetail(bankDetailsData) {
    return this.http.post<any>('Entity/AddBankDetail', bankDetailsData)
  }

  addAuditorsDetail(auditorsDetailsData) {
    return this.http.post<any>('Entity/AddAuditorDetail', auditorsDetailsData)
  }

  addEditBeneficairyDetails(beneficairyData) {
    return this.http.post<any>('Entity/AddEditEntityBeneficiaries', beneficairyData)
  }

  getEntityBeneficiaryList(entityId) {
    return this.http.get<any>('Entity/GetEntityBeneficiaryList?EntityId=' + entityId + '');
  }

  deleteBeneficiary(beneficairyId){
    return this.http.get<any>('Entity/DeleteBeneficairyById?beneficiaryId='+ beneficairyId + '')
  }

  addEditEntityBareTrust(bareTrust) {
    return this.http.post<any>('Entity/PostBareTrust', bareTrust)
  }

  addEditEntityTrustee(entityData) {
    return this.http.post<any>('Entity/AddEditEntityTrustee', entityData)
  }

  addEditTrustIndividualDetail(entipersonalDetail) {
    return this.http.post<any>('Entity/PostEntityPersonalDetails', entipersonalDetail)
  }

  getTrusteeListForSMSFIndividual(clientId, trusteeId) {
    return this.http.get<any>('Entity/GetEntityTrusteeListSMSFIndividual?ClientId=' + clientId + '&TrusteeId=' + trusteeId)
  }

  addEditSMSFTrusteeDetails(trusteeData) {
    return this.http.post<any>('Entity/AddEditSMSFTrustee', trusteeData)
  }

  getTrusteeListSMSF(entityId, clientId) {
    return this.http.get<any>('Entity/GetEntityTrusteeListSMSF?entityId=' + entityId + '&clientId=' + clientId)
  }

  deleteTrusteeForSMSF(trusteeId){
    return this.http.get<any>('Entity/DeleteTrusteeForSMSFById?trusteeId='+ trusteeId + '')
  }

  getTaxAgents() {
    return this.http.get<any>('UserManagement/GetAllTaxAgents')
  }

  getsoftwaredetails(clientId, entityId) {
    return this.http.get<any>('Client/GetSoftwareDetails?clientId=' + clientId + '&entityId=' + entityId)
  }

  softwaredetails(softwareDetailId) {
    return this.http.get<any>('Client/GetSoftwareDetailById?softwareDetailId='+ softwareDetailId + '')
  }

  addsoftwaredetails(softwaredetails) {
    return this.http.post<any>('Client/PostSoftwareDetails', softwaredetails)
  }

  deletesoftwaredetails(id) {
    return this.http.get<any>('Client/DeleteSoftwareDetailById?softwareDetailId='+ id + '')
  }

  getStaffLists(clientId) {
    return this.http.get<any>('Client/GetAssignStaffListForClient?clientId='+clientId);
  }

  GetAllEntityforClient(clientId) {
    return this.http.get<any>('Client/GetAllEntityforClient?clientId=' + clientId);
  }

  DeleteEntityMappingById(id) {
    return this.http.get<any>('Entity/DeleteEntityMappingById?mappingId=' + id);
  }

  GetAllBusinessNumber() {
    return this.http.get<any>('Entity/GetAllBusinessNumber')
  }

  addEditEntityReferalDetails(entityData) {
    return this.http.post<any>('Entity/PostEntityReferalDetails', entityData)
  }

  addEditCorporateEntityInformation(entityData) {
    return this.http.post<any>('Entity/PostCorporateEntityDetails', entityData)
  }

  GetEntityDetailsByEntityId(entityId) {
    return this.http.get<any>('Entity/GetEntityDetails?entityId=' + entityId + '');
  }

  postentity(entity) {
    return this.http.post<any>('Entity/PostAddAssignClientToEntity', entity, { headers: this.headers });
  }

  DeleteStaffMappingById(id) {
    return this.http.get<any>('Entity/DeleteStaffMappingById?mappingId=' + id);
  }

  Getentity(isArchive) {
    return this.http.get<any>('Entity/GetAllEntities?isArchive=' + isArchive);
  }

  ArchiveEntity(entityId) {
    return this.http.get<any>('Entity/ArchiveEntity?entityId=' + entityId)
  }

  GetLinkedClient(entityId) {
    return this.http.get('Entity/GetAllEntityByClientId/' + entityId + '');
  }

  GetEntityTypes() {
    const headers: HttpHeaders = new HttpHeaders();
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
    headers.set('Authorization', "Bearer " + localStorage.getItem("AccessToken"));
    return this.http.get<any>('Entity/GetEntityTypes', { headers: headers });
  }
}
